import uz from './uz'
import ru from './ru'
import en from './en'

export default {
    uz, ru, en
}